// extracted by mini-css-extract-plugin
export default {"parent":"LoadingIndicator-styles-module--parent--Vhqwd"};